module.exports = __webpack_public_path__ + "1b58a61c856cb269aa9a675fe7b4f390.svg";